// Static list of 6-character AI tokens for loading animations
// These represent simulated AI processing tokens
export const AI_TOKENS = [
  '7A4B2C',
  '9E1F5D',
  '3C8A6B',
  '5D2E9F',
  '8B7C4A',
  '2F6E1D',
  '4A9B7C',
  '6E3F8D',
  '1C5A9B',
  '9D4E2F',
  '7B6C8A',
  '3E9F1D',
  '5A2B7C',
  '8F4D6E',
  '2C9A5B',
  '6D1E8F',
  '4B7A3C',
  '9E5D2F',
  '1A8B6C',
  '7F3E9D',
  '5C2A8B',
  '3D6F1E',
  '8A4B7C',
  '2E9D5F',
  '6B1C8A',
  '4F7E3D',
  '9A5B2C',
  '1D8F6E',
  '7C3A9B',
  '5E2D8F',
  '3B6A1C',
  '8D4F7E',
  '2A9C5B',
  '6F1E8D',
  '4C7B3A',
  '9E5F2D',
  '1B8A6C',
  '7D3E9F',
  '5A2C8B',
  '3F6D1E',
  '8B4A7C',
  '2E9F5D',
  '6C1A8B',
  '4D7E3F',
  '9B5A2C',
  '1E8D6F',
  '7A3C9B',
  '5D2E8F',
  '3C6B1A',
  '8F4D7E',
  '2B9A5C',
  '6E1F8D',
  '4A7C3B',
  '9D5E2F',
  '1C8B6A',
  '7E3D9F',
  '5B2A8C',
  '3D6E1F',
  '8A4C7B',
  '2F9D5E',
  '6B1A8C',
  '4E7F3D',
  '9C5B2A',
  '1D8E6F',
  '7B3A9C',
  '5E2D8A',
  '3A6C1B',
  '8D4E7F',
  '2C9B5A',
  '6F1D8E',
  '4B7A3C',
  '9E5D2F',
  '1A8C6B',
  '7F3E9D',
  '5C2B8A',
  '3D6F1E',
  '8B4A7C',
  '2E9D5F',
  '6A1C8B',
  '4F7E3D',
  '9A5C2B',
  '1D8F6E',
  '7C3B9A',
  '5E2D8F',
];

// Pre-generated token patterns for instant loading
const PATTERN_CACHE = [];
const CACHE_SIZE = 10;

// Initialize pattern cache
for (let p = 0; p < CACHE_SIZE; p++) {
  const pattern = [];
  for (let i = 0; i < 100; i++) {
    const isActive = Math.random() > 0.68; // 32% chance to be active
    const token = AI_TOKENS[Math.floor(Math.random() * AI_TOKENS.length)];
    const delay = (i * 0.06) % 2.2; // Staggered delays

    pattern.push({
      token,
      isActive,
      delay,
    });
  }
  PATTERN_CACHE.push(pattern);
}

// Generate a static pattern of AI tokens - no regeneration needed for smooth performance
export const generateAITokenPattern = (totalTokens = 100) => {
  // Always use the first pre-cached pattern for consistent, smooth animations
  if (totalTokens === 100 && PATTERN_CACHE.length > 0) {
    return [...PATTERN_CACHE[0]]; // Always return the same pattern for consistency
  }

  // Fallback for custom sizes (rarely used)
  const pattern = [];
  for (let i = 0; i < totalTokens; i++) {
    const isActive = i % 3 === 0; // Predictable pattern instead of random
    const token = AI_TOKENS[i % AI_TOKENS.length];
    const delay = (i * 0.06) % 2.2;

    pattern.push({
      token,
      isActive,
      delay,
    });
  }
  return pattern;
};
